import {Col, Row,} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import Back from "../layout/template/back";
import {Link, useLocation} from "react-router-dom";
import DataTable from "react-data-table-component";
import APIService from "../../services/ApiService";
import DateTimeUtils from "../../services/DateTimeUtils";
import ApiService from "../../services/ApiService";


const AdminDetailCourse = () => {
    const location = useLocation();
    const [courseData, setCourseData] = useState();
    const [participantForCourse, setParticipantForCourse] = useState([])
    const [days, setDays] = useState([]);

    useEffect(() => {

        let courseId = location.state?.from;

        if(courseId !== undefined){
            APIService.getCourseById(courseId).then(coursePayload=> {
                APIService.getDaysForCourse(courseId).then(days=> {
                    setDays(days)
                })
                APIService.getPoolById(coursePayload.piscinaId).then(piscina => {
                    ApiService.getAdminParticipantForCourse(courseId).then(courseParticipants => {
                        let columns = []
                        courseParticipants.participants.forEach(participant => {
                            console.log(JSON.stringify(participant))

                            columns.push({
                                id: participant.id,
                                name: participant.firstName + " " + participant.lastName,
                                birth: DateTimeUtils.getParticipantDob(participant),
                                level: participant.currentLevel
                            })
                        })

                        setParticipantForCourse(columns)
                    })
                    let courseWithPiscina = Object.assign(coursePayload, {luogo: piscina.place.split(";")[0]});

                    console.log(JSON.stringify(courseWithPiscina))
                    setCourseData(courseWithPiscina);
                })
            })
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {

    }, [courseData]);

    const columns = [
        {
            name: 'Nome partecipate',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Data di nascita',
            selector: row => row.birth,
            sortable: true,
        },
        {
            name: 'Livello',
            selector: row => row.level,
            sortable: true,
        },
        {
            cell: () => {/*
                <Button variant={'primary'} onClick={(e) => handleEliminaPartecipante(e, selectedRow)}
                        className={'btn btn-sm btn-primary text-nowrap'}>Elimina</Button>*/
            },
            right: true,
        },
    ];

    return (
        <>
            <Row>
                <Col xs={12}>
                    <Row>
                        <Col>
                            <Back/>
                        </Col>
                    </Row>
                    <Row className={'justify-content-between'}>
                        <Col>
                            <div className={'title-page-section mt-5'}>
                                <h2 className={'title'}>Dettaglio Corso</h2>
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col xs={12} lg={6}>

                    <Row>
                        <Col xs={12} lg={4}>
                            <div className={'paragraph-section mt-3 mb-2'}>
                                <p className={'fw-bold mb-0'}>Titolo:</p>
                                <p>{courseData && courseData.title}</p>
                                {courseData && <Link to={`/shop/course/${courseData.id}`}><i className={"icon arrow me-1"}/>vedi corso
                                    sullo shop</Link>}
                            </div>
                        </Col>
                        <Col xs={12} lg={4}>
                            <div className={'paragraph-section mt-3 mb-2'}>
                                <p className={'fw-bold mb-0'}>Luogo:</p>
                                <p>{courseData && courseData.luogo}</p>
                            </div>
                        </Col>
                        <Col xs={12} lg={4}>
                            <div className={'paragraph-section mt-3 mb-2'}>
                                <p className={'fw-bold mb-0'}>Categoria:</p>
                                <p>{courseData && courseData.levelCourseId}</p>
                            </div>
                        </Col>
                        <Col xs={12} lg={4}>
                            <div className={'paragraph-section mt-3 mb-2'}>
                                <p className={'fw-bold mb-0'}>Id Corso:</p>
                                <p>{courseData && courseData.id}</p>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12}>
                            <div className={'paragraph-section mt-3 mb-2'}>
                                <p className={'fw-bold mb-0'}>Date:</p>
                                <table className="table table-columns-border">
                                    <thead>
                                    <tr>
                                        <th scope={'col'}>Giorno</th>
                                        <th scope={'col'}>Data</th>
                                        <th scope={'col'}>Ora</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {days.length > 0 ?
                                        days.map((day, index) =>
                                            <tr>
                                                <td>{DateTimeUtils.fromDateToDayOfWeek(day.day)}</td>
                                                <td>{DateTimeUtils.formatStartStringAsDate(day.day)}</td>
                                                <td>{day.pause? "Pause" : (DateTimeUtils.convertUTCToLocalTime(day.start) + "-" + DateTimeUtils.convertUTCToLocalTime(day.end))}</td>
                                            </tr>
                                        )
                                        :
                                        <></>
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} lg={6}>
                            <div className={'paragraph-section mt-3 mb-2'}>
                                <p className={'fw-bold mb-0'}>Numero massimo partecipanti</p>
                                <p>{courseData && courseData.maxParticipants}</p>
                            </div>
                        </Col>
                        <Col xs={12} lg={6}>
                            <div className={'paragraph-section mt-3 mb-2'}>
                                <p className={'fw-bold mb-0'}>Visibilità sullo shop</p>
                                {courseData && <p>{DateTimeUtils.formatStartStringAsDate(courseData.visibilityStart)} al {DateTimeUtils.formatStartStringAsDate(courseData.visibilityEnd)}</p>}
                            </div>
                        </Col>
                    </Row>

                </Col>
            </Row>
            <Row className={'mt-3'}>
                <Col xs={12}>
                    {participantForCourse.length > 0 ?<DataTable
                        columns={columns}
                        data={participantForCourse}
                        highlightOnHover
                        pagination
                        responsive
                        striped
                        paginationPerPage={25}
                        paginationRowsPerPageOptions={[25, 50, 100]}
                    /> : ""}
                </Col>
            </Row>
        </>

    );
}

export default AdminDetailCourse;
